var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#22AD5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 5.20312C8.24258 5.20312 5.20508 8.24063 5.20508 11.9981C5.20508 15.7556 8.24258 18.8156 12.0001 18.8156C15.7576 18.8156 18.8176 15.7556 18.8176 11.9981C18.8176 8.24063 15.7576 5.20312 12.0001 5.20312ZM12.0001 17.8031C8.80508 17.8031 6.21758 15.1931 6.21758 11.9981C6.21758 8.80313 8.80508 6.21563 12.0001 6.21563C15.1951 6.21563 17.8051 8.82562 17.8051 12.0206C17.8051 15.1931 15.1951 17.8031 12.0001 17.8031Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9348 9.90575L11.2573 12.5157L10.0423 11.3232C9.83977 11.1207 9.52477 11.1432 9.32227 11.3232C9.11977 11.5257 9.14227 11.8407 9.32227 12.0432L10.7623 13.4382C10.8973 13.5732 11.0773 13.6407 11.2573 13.6407C11.4373 13.6407 11.6173 13.5732 11.7523 13.4382L14.6548 10.6482C14.8573 10.4457 14.8573 10.1307 14.6548 9.92825C14.4523 9.72575 14.1373 9.72575 13.9348 9.90575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.8877d1340983e167598ebc1bd8573454.svg";
export { ForwardRef as ReactComponent };